import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import getAuthorityLevel from 'src/app/utils/getAuthorityLevel';
import getPermission from 'src/app/utils/getPermission';
import { useClient } from 'jsonapi-react';
import React, { useState } from 'react';
import { CourseClassroomModuleItem } from './course-classroom-module-item';
import { useSession } from 'src/app/hooks/useSession';
import { ClassroomModuleList, ClassroomSidebar } from '@/components/custom/classroom';
import { Button } from '@/components/ui/button';
import { Badge, BadgeGroup } from '@/components/ui/badge';
import { CardProgressWrapper } from '@/components/ui/card';

export function CourseClassroomSidebar(props) {
  const { learnigSystem, setActiveTabs, learnSystemContents, setSelectedItem, selectedItem, setSelectedContent, selectedContent, learnigSystemUser, getLearnSystemContents } = props;
  const { t } = useTranslation();
  const [active, setActive] = useState('');

  const changeTab = tab => {
    setActiveTabs(tab);
    window.scrollTo({
      top: 400,
      behavior: 'smooth'
    });
  };

  const authorityLevel = getAuthorityLevel();
  const client = useClient();

  const updateLearningSystemUserItems = async ls_id => {
    const requestParams = {
      has_new_message: false
    };
    const { error } = await client.mutate([`/learning_system_user_items/${ls_id}`], requestParams);

    if (error) {
      console.log(error);
    }
  };

  const updateLearningSystemItems = async ls_id => {
    const requestParams = {
      has_new_message: false
    };
    const { error } = await client.mutate([`/learning_system_items/${ls_id}`], requestParams);

    if (error) {
      console.log(error);
    }
  };

  const currentUser = useSession()?.session?.user;
  const hasManagePermission = getPermission('Gerenciar conteúdo', 'Cursos');

  const hasModulePermission = hasManagePermission && (!learnigSystem?.['authored-by-user'] || (learnigSystem?.['authored-by-user'] && currentUser.id === learnigSystem?.['user-id']) || currentUser?.profileNames.includes('Administrador'));

  return (
    <ClassroomSidebar>
      {hasModulePermission && (
        <Button
          fullWidth
          className="mb-4"
        >
          <Link to={`/curso/admin/gerenciar/${learnigSystem?.course?.id}/${learnigSystem?.id}/disciplinas-e-aulas/d`}>Gerenciar módulo</Link>
        </Button>
      )}

      {authorityLevel === 'student' &&
        (learnigSystemUser?.percent === 100 ? (
          <BadgeGroup>
            <Badge
              variant="success"
              size="sm"
              className="mb-4"
            >
              {t('textsCommon.tagConcluded')}
            </Badge>
          </BadgeGroup>
        ) : (
          <CardProgressWrapper
            percentage={Math.round(learnigSystemUser?.percent || 0)}
            className="mb-4"
          />
        ))}

      <ClassroomModuleList>
        {(learnSystemContents || []).map((learnSystemContent, index) => {
          const learningSystemItems = learnSystemContent['learning-system-items'] || [];
          if (learningSystemItems.some(learningSystemItem => learningSystemItem.unrequired)) {
            learnSystemContent['is-allowed'] = true;
          }

          return (
            <CourseClassroomModuleItem
              changeTab={changeTab}
              learnigSystem={learnigSystem}
              learningSystemItems={learningSystemItems}
              learnSystemContents={learnSystemContents}
              selectedItem={selectedItem}
              setSelectedItem={setSelectedItem}
              selectedContent={selectedContent}
              setSelectedContent={setSelectedContent}
              learnSystemContent={learnSystemContent}
              active={active}
              setActive={setActive}
              authorityLevel={authorityLevel}
              updateLearningSystemItems={updateLearningSystemItems}
              updateLearningSystemUserItems={updateLearningSystemUserItems}
              getLearnSystemContents={getLearnSystemContents}
              index={index}
              key={index}
            />
          );
        })}
      </ClassroomModuleList>
    </ClassroomSidebar>
  );
}
